import memoize from 'app/api/memoize'
import { createAction } from 'redux-actions'
import { selectors as OrgSelectors } from 'app/modules/org'
import { api } from './api'
import { constants } from './constants'
import * as selectors from './selectors'
import { captureException } from 'utils/SentryHelpers'

export const fetchTagListPending = createAction(constants.FETCH_TAG_LIST_PENDING)
export const fetchTagListFailed = createAction(constants.FETCH_TAG_LIST_FAILED)
export const receiveTagList = createAction(constants.RECEIVE_TAG_LIST)

export const fetchTagList = memoize(() => (dispatch, getState) => {
  dispatch(fetchTagListPending())
  const orgId = OrgSelectors.orgId(getState())
  return api.fetchList(orgId)
    .then(tagList => dispatch(receiveTagList(tagList)))
    .catch(error => {
      dispatch(fetchTagListFailed(error))
      captureException(error)
      throw(error)
    })
})

export const createTagPending = createAction(constants.CREATE_TAG_PENDING)
export const createTagFailed = createAction(constants.CREATE_TAG_FAILED)
export const updateTagPending = createAction(constants.UPDATE_TAG_PENDING)
export const updateTagFailed = createAction(constants.UPDATE_TAG_FAILED)
export const deleteTagPending = createAction(constants.DELETE_TAG_PENDING)
export const deleteTagFailed = createAction(constants.DELETE_TAG_FAILED)
export const deleteTagSuccess = createAction(constants.DELETE_TAG_SUCCESS)
export const receiveTag = createAction(constants.RECEIVE_TAG)

export const createTag = (tag) => (dispatch, getState) => {
  dispatch(createTagPending(tag))
  const orgId = OrgSelectors.orgId(getState())
  return api.create(orgId, tag)
    .then(tag => dispatch(receiveTag(tag)))
    .catch(error => {
      dispatch(createTagFailed({ error, tag }))
      captureException(error)
      throw(error)
    })
}

export const updateTag = (tag) => (dispatch, getState) => {
  const oldTag = selectors.tag(getState(), { tagId: tag.id })
  const orgId = OrgSelectors.orgId(getState())
  dispatch(updateTagPending(tag))
  return api.updateTag(orgId, tag)
    .then(tag => dispatch((tag)))
    .catch(error => {
      dispatch(updateTagFailed({ error, tag: oldTag }))
      captureException(error)
      throw(error)
    })
}

export const deleteTag = (tagId) => (dispatch, getState) => {
  const orgId = OrgSelectors.orgId(getState())
  const oldTag = selectors.tag(getState(), { tagId })
  dispatch(deleteTagPending(tagId))
  return api.delete(orgId, tagId)
    .then(() => dispatch(deleteTagSuccess()))
    .catch(error => {
      dispatch(deleteTagFailed({ error, tag: oldTag }))
    })
}

export const tagConversationPending = createAction(constants.TAG_CONVERSATION_PENDING)
export const tagConversationSuccess = createAction(constants.TAG_CONVERSATION_SUCCESS)
export const tagConversationFailed = createAction(constants.TAG_CONVERSATION_FAILED)

export const tagConversation = (conversationId, tagIds) => (dispatch) => {
  dispatch(tagConversationPending())
  return api.tagConversation(conversationId, tagIds)
    .then(() => dispatch(tagConversationSuccess()))
    .catch((error) => {
      dispatch(tagConversationFailed(error))
      captureException(error)
      throw(error)
    })
}

export const untagConversationPending = createAction(constants.UNTAG_CONVERSATION_PENDING)
export const untagConversationSuccess = createAction(constants.UNTAG_CONVERSATION_SUCCESS)
export const untagConversationFailed = createAction(constants.UNTAG_CONVERSATION_FAILED)

export const untagConversation = (conversationId, tagIds) => (dispatch) => {
  dispatch(untagConversationPending())
  return api.untagConversation(conversationId, tagIds)
    .then(() => dispatch(untagConversationSuccess()))
    .catch((error) => {
      dispatch(untagConversationFailed(error))
      captureException(error)
      throw(error)
    })
}

export const tagCompanyPending = createAction(constants.TAG_COMPANY_PENDING)
export const tagCompanyFailed = createAction(constants.TAG_COMPANY_FAILED)
export const tagCompanySuccess = createAction(constants.TAG_COMPANY_SUCCESS)

export const tagCompany = (companyId, tagIds) => (dispatch) => {
  dispatch(tagCompanyPending())
  return api.tagCompany(companyId, tagIds)
    .then(() => dispatch(tagCompanySuccess()))
    .catch((error) => {
      dispatch(tagCompanySuccess(error))
      captureException(error)
      throw(error)
    })
}

export const untagCompanyPending = createAction(constants.UNTAG_COMPANY_PENDING)
export const untagCompanySuccess = createAction(constants.UNTAG_COMPANY_SUCCESS)
export const untagCompanyFailed = createAction(constants.UNTAG_COMPANY_FAILED)

export const untagCompany = (companyId, tagIds) => (dispatch) => {
  dispatch(untagCompanyPending())
  return api.untagCompany(companyId, tagIds)
    .then(() => dispatch(untagCompanySuccess()))
    .catch((error) => {
      dispatch(untagCompanyFailed(error))
      captureException(error)
      throw(error)
    })
}

export const tagEndUserPending = createAction(constants.TAG_END_USER_PENDING)
export const tagEndUserFailed = createAction(constants.TAG_END_USER_FAILED)
export const tagEndUserSuccess = createAction(constants.TAG_END_USER_SUCCESS)

export const tagEndUser = (endUserId, tagIds) => (dispatch) => {
  dispatch(tagEndUserPending())
  return api.tagEndUser(endUserId, tagIds)
    .then(() => dispatch(tagEndUserSuccess()))
    .catch((error) => {
      dispatch(tagEndUserFailed(error))
      captureException(error)
      throw(error)
    })
}

export const untagEndUserPending = createAction(constants.UNTAG_END_USER_PENDING)
export const untagEndUserFailed = createAction(constants.UNTAG_END_USER_FAILED)
export const untagEndUserSuccess = createAction(constants.UNTAG_END_USER_SUCCESS)

export const untagEndUser = (endUserId, tagIds) => (dispatch) => {
  dispatch(untagEndUserPending())
  return api.untagEndUser(endUserId, tagIds)
    .then(() => dispatch(untagEndUserSuccess()))
    .catch((error) => {
      dispatch(untagEndUserFailed(error))
      captureException(error)
      throw(error)
    })
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/tags/actions.js